import React from 'react';
import { Torneio } from '../services/torneioService';
import LocalizacaoMapaView from './local/LocalizacaoMapaView';
import { formatDataTorneioBR } from '../utils/date';

interface TournamentSidebarProps {
  torneio: Torneio;
  onInscreva: () => void;
  isFollowing?: boolean;
  followLoading?: boolean;
  onFollow?: () => void;
}

const TournamentSidebar: React.FC<TournamentSidebarProps> = ({
  torneio,
  onInscreva,
  isFollowing = false,
  followLoading = false,
  onFollow,
}) => {
  const organizador = torneio.organizadores?.[0] ?? null;

  const formatarTelefone = (telefone: string): string =>
    telefone.replace(/\D/g, '');

  return (
    <div className="col-xl-3 mb-3 mb-xl-0">
      <div className="d-flex flex-column gap-3">
        {/* Botao Inscreva-se */}
        <button
          className="btn btn-primary w-100"
          onClick={onInscreva}
        >
          Inscreva-se
        </button>

        {/* Botao Seguir */}
        {onFollow && (
          <button
            className={`btn w-100 ${isFollowing ? 'btn-secondary' : 'btn-primary'}`}
            onClick={onFollow}
            disabled={followLoading}
          >
            {followLoading ? 'Aguarde...' : isFollowing ? 'Seguindo' : 'Seguir'}
          </button>
        )}

        {/* Secao Sobre */}
        <div className="card border-0 bg-grey">
          <div className="card-body">
            <h5 className="fw-700 text-grey-900 font-xss mb-3">Sobre</h5>
            {torneio.dataInicio && (
              <p className="font-xssss text-grey-700 mb-1">
                <i className="bi bi-calendar-event me-2"></i>
                {formatDataTorneioBR(torneio.dataInicio)}
                {torneio.dataFim && (
                  <> a {formatDataTorneioBR(torneio.dataFim)}</>
                )}
              </p>
            )}
            {torneio.local && (
              <p className="font-xssss text-grey-700 mb-1">
                <i className="bi bi-geo-alt-fill me-2"></i>
                {torneio.local.nome}
                {torneio.local.endereco && (
                  <>
                    {' - '}
                    {torneio.local.endereco.cidade?.nome}
                    {torneio.local.endereco.cidade?.uf && (
                      <>, {torneio.local.endereco.cidade.uf}</>
                    )}
                  </>
                )}
              </p>
            )}
            {torneio.local && (
              <LocalizacaoMapaView urlLocalizacao={torneio.local?.urlLocalizacao} />
            )}
            {torneio.descricao && (
              <div
                className="font-xssss text-grey-700 mt-2"
                dangerouslySetInnerHTML={{ __html: torneio.descricao }}
              />
            )}
          </div>
        </div>

        {/* Secao Contatos */}
        {organizador && (
          <div className="card border-0 bg-grey">
            <div className="card-body">
              <h5 className="fw-700 text-grey-900 font-xss mb-3">Contatos</h5>
              <div className="d-flex flex-column gap-2">
                <div>
                  <p className="font-xssss fw-600 text-grey-900 mb-1">
                    {organizador.nome}
                  </p>
                  {organizador.telefone && (
                    <p className="font-xssss text-grey-700 mb-2">
                      {organizador.telefone}
                    </p>
                  )}
                </div>
                {organizador.telefone && (
                  <a
                    href={`https://wa.me/${formatarTelefone(organizador.telefone)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-success btn-sm w-100"
                  >
                    <i className="bi bi-whatsapp me-2"></i>
                    Mensagem
                  </a>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Banner Vertical */}
        {torneio.bannerVUrl && (
          <div className="card border-0">
            <img
              src={torneio.bannerVUrl}
              alt={`Banner vertical ${torneio.nome}`}
              className="rounded-xl w-100"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default TournamentSidebar;
